import { useCallback, useEffect, useState } from 'react';
import { describeError } from '../../services/errorMessage';
import { fetchFristen } from '../../services/sifa/sifaBetreuungService';
import { SifaFrist } from '../../services/sifa/betreuungTypes';

/**
 * Fristenregister eines SiFa-Projekts (sifa_fristen, Nr. 92) — alle Zeilen,
 * auch erledigte: die Liste filtert selbst („Erledigte anzeigen"), und die
 * Historie einer wiederkehrenden Frist entsteht genau aus diesen Zeilen.
 */
export const useFristen = (projectId: string | null | undefined) => {
  const [fristen, setFristen] = useState<SifaFrist[]>([]);
  const [laden, setLaden] = useState(true);
  const [fehler, setFehler] = useState<string | null>(null);

  const neuLaden = useCallback(async () => {
    if (!projectId) { setFristen([]); setLaden(false); return; }
    setLaden(true);
    setFehler(null);
    try {
      setFristen(await fetchFristen(projectId));
    } catch (e) {
      setFehler(describeError(e));
    } finally {
      setLaden(false);
    }
  }, [projectId]);

  useEffect(() => { void neuLaden(); }, [neuLaden]);

  /** Eine gespeicherte Zeile einsetzen oder anhaengen (Anlegen, Bearbeiten, Erledigen, Folgezeile). */
  const uebernehmen = useCallback((geaendert: SifaFrist) => {
    setFristen((prev) => (prev.some((f) => f.id === geaendert.id)
      ? prev.map((f) => (f.id === geaendert.id ? geaendert : f))
      : [...prev, geaendert]));
  }, []);

  const entfernen = useCallback((id: string) => {
    setFristen((prev) => prev.filter((f) => f.id !== id));
  }, []);

  return { fristen, laden, fehler, neuLaden, uebernehmen, entfernen };
};
